import React from "react";
import { useEffect } from "react";
import styled from "styled-components";
import "./FAQStyles.css";
const FAQ = () => {
  useEffect(() => {
    const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");

    accordionItemHeaders.forEach((accordionItemHeader) => {
      accordionItemHeader.addEventListener("click", (event) => {
        const currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");
        if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
          currentlyActiveAccordionItemHeader.classList.toggle("active");
          currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }

        accordionItemHeader.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
          accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
        } else {
          accordionItemBody.style.maxHeight = 0;
        }
      });
    });
  });
  return (
    <FAQTag>
      <div className='reveal'>
        <h1>Frequently Asked Questions</h1>

        <div className='accordion'>
          {/* <div className="accordion-item">
        <div className="accordion-item-header">
          Which subjects are considered in the process of Department Change?
        </div>
        <div className="accordion-item-body">
            <div className="accordion-item-body-content">
            In the online academic sessions, 7 theory subjects were considered for DepC but in the offline sessions all subjects other than EAA are considered.</div>
        </div>
    </div> */}

          <div className='accordion-item'>
            <div className='accordion-item-header'>
              What should I do if my allotted mentor does not respond to my queries?
            </div>
            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                You can mail your grievance along with your and your mentor's details to us at info.swgiitkgp@gmail.com.
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>
              What is an additional subject, and what are the rules regarding an additional subject?
            </div>
            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                Additional subjects are the subjects, not covered in the regular curriculum requirement, which the
                students can choose from 3rd year onwards to explore their interests. Students with CGPA greater than or
                equal to 7.50 without any backlog are allowed to choose additional subject(s) (maximum 5 per semester).
                The grades obtained in the additional subjects do not contribute to the SGPA/CGPA of a student.
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>Where can I get details about scholarships?</div>
            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                You may see the Academic Information on the Resources page of this site.
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>What is a breadth subject?</div>
            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                A portion of the curriculum includes breadth subjects. There is a curriculum that is specific to each
                department. However, breadth is a required component of the curriculum that is typically unconnected to
                the parent department, and your GPA in breadth counts toward your overall GPA.
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>
              Where can I get details about the future prospects of each department?
            </div>
            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                You can look at our Know Your Department blogs in the blogs page of this website to read the answers to
                Frequently Asked Questions about your respective departments.
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>
              Can BTech students sit for CDC internships again next year after converting to dual degree?
            </div>
            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                Students are not eligible to participate in CDC placement drives again after a dual conversion if they
                secured an internship through CDC in the previous year. Only those students who were unable to obtain an
                internship through CDC in their first attempt are permitted to participate again.
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>
              What is the role of a faculty advisor for students at IIT Kharagpur?
            </div>
            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                <p>
                  At IIT Kharagpur, faculty advisors serve as a student's primary academic guide and mentor. Assigned directly from the student's home department, they assist with course planning, semester registration via the ERP System, and continuous monitoring of academic performance.
                </p>

                <p>Their core responsibilities include:</p>

                <ul>
                  <li>
                    <strong>Course Planning & Registration:</strong> Assisting students in designing course charts, selecting electives, and approving Registration Cards.
                  </li>
                  <li>
                    <strong>Performance Monitoring:</strong> Tracking attendance and academic progress and helping students with low CGPA.
                  </li>
                  <li>
                    <strong>Administrative Liaison:</strong> Acting as the link between students and the Dean of Undergraduate Studies.
                  </li>
                  <li>
                    <strong>Mentorship:</strong> Counseling students and referring them to support services when needed.
                  </li>
                  <li>
                    <strong>Special Category Support:</strong> Providing extra guidance to academically weaker or reserved-category students.
                  </li>
                </ul>

                <p>
                  If you are an IIT KGP student, your faculty advisor should be your first point of contact for academic and administrative processes.
                </p>
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>
              How do I book the institute's guest house?
            </div>

            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                <p>
                  Booking a room at the Technology Guest House (TGH) involves a specific two-step approval process. You cannot book directly-you must first get official clearance from your Faculty Advisor (FacAd).
                </p>

                <p><strong>Here is exactly how to do it:</strong></p>

                <p><strong>Step 1: Get Approval from your FacAd</strong></p>
                <ul>
                  <li>Send a formal email to your Faculty Advisor requesting permission for the booking.</li>
                  <li>
                    <strong>What to include:</strong> Your parents' full names, exact dates of the visit, and the purpose of their stay.
                  </li>
                  <li>
                    <strong>The Goal:</strong> Get a reply explicitly stating their approval.
                  </li>
                </ul>

                <p><strong>Step 2: Forward the Approval to Technology Guest House (TGH)</strong></p>
                <ul>
                  <li>
                    Forward the entire email thread to <strong>tgh@hijli.iitkgp.ac.in</strong>.
                  </li>
                  <li>
                    Clearly mention that you have obtained your FacAd’s approval.
                  </li>
                  <li><strong>Re-confirm the booking details:</strong></li>
                  <ul>
                    <li>Name of the parent(s) visiting</li>
                    <li>Date(s) of the visit (Check-in and Check-out)</li>
                    <li>Purpose of the visit</li>
                  </ul>
                </ul>
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>
              What should I do if I lose my student ID card?
            </div>

            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                <p>
                  If you lose your ID card, you can get a replacement issued by completing the following steps:
                </p>

                <p><strong>Step 1: File an FIR</strong></p>
                <ul>
                  <li>Visit the local police station to file a First Information Report (FIR).</li>
                  <li>Write two copies of the formal letter on an A4 sheet.</li>
                  <li>
                    <strong>Formatting:</strong> Fold a margin on the left side and fold the sheet horizontally into three equal parts before submitting.
                  </li>
                </ul>

                <p><strong>Step 2: Obtain and Fill the Academic Form</strong></p>
                <ul>
                  <li>Collect the duplicate ID card application form from the Academic Section (Main Building).</li>
                  <li>Fill in the details carefully.</li>
                  <li>Get it signed by your Warden or Head of Department (HOD).</li>
                  <li>Follow any additional instructions provided by the Academic Section staff.</li>
                </ul>

                <p><strong>Step 3: Pay the Fine</strong></p>
                <ul>
                  <li>Pay a fine of <strong>₹1000</strong> at the State Bank of India (SBI) branch near the campus main entrance.</li>
                  <li>Fill out four pink deposit slips at the bank.</li>
                  <li>Cash payment is recommended for faster processing.</li>
                  <li>Bank staff can assist you if needed.</li>
                </ul>

                <p><strong>Step 4: Submit Your Documents</strong></p>
                <ul>
                  <li>Return to the Academic Section office.</li>
                  <li>Submit the following:</li>
                  <ul>
                    <li>Signed application form</li>
                    <li>Copy of the police FIR</li>
                    <li>One stamped payment slip from the bank</li>
                  </ul>
                </ul>

                <p>
                  <strong>Note:</strong> If you submit all required documents before lunch, your new ID card is typically ready by the evening of the same day.
                </p>
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>
              What to do if you lose your medical record book?
            </div>

            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                <p>
                  You should take good care of your medical record book and avoid misplacing it to prevent any administrative risks.
                </p>

                <p><strong>If you do lose it:</strong></p>

                <ul>
                  <li>Visit your Hall of Residence office.</li>
                  <li>Request the staff to issue a replacement medical record book.</li>
                  <li>Follow any instructions provided by the hall office.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>
              How can we change our hall of residence?
            </div>

            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                <p>
                  To change your Hall of Residence, the entire process is overseen and regulated by the Hall Management Centre (HMC). You cannot simply swap rooms or move into another hall without official approval.
                </p>

                <p><strong>Here is how the process works:</strong></p>

                <ul>
                  <li>
                    <strong>HMC Permission is Mandatory:</strong> Any hall change requires formal clearance and approval from the HMC administration.
                  </li>
                  <li>
                    <strong>Valid Justification Required:</strong> Requests are evaluated based on specific and genuine reasons, such as serious medical or mental health concerns.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>
              What should I do if I miss an examination?
            </div>

            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                <p>
                  If you miss or are certain you will miss an exam, you should immediately inform the relevant authorities and initiate the formal process.
                </p>

                <p><strong>Step 1: Initial Email Notification</strong></p>
                <ul>
                  <li>
                    Send an email to the course instructor as soon as possible (preferably before the exam, or immediately after in emergencies).
                  </li>
                  <li>
                    CC your Faculty Advisor and Head of Department (HOD).
                  </li>
                  <li>
                    Clearly state your reason for missing the exam.
                  </li>
                  <li>
                    Attach supporting documents (e.g., medical certificate from B.C. Roy Technology Hospital if applicable).
                  </li>
                </ul>

                <p><strong>Step 2: Formal Application Process</strong></p>
                <ul>
                  <li>
                    Submit a formal hard copy application explaining your situation.
                  </li>
                  <li>
                    Attach official proof/documents.
                  </li>
                  <li>
                    Get the application signed by your Faculty Advisor and HOD.
                  </li>
                  <li>
                    Submit it to the course instructor.
                  </li>
                </ul>

                <p><strong>Step 3: Alternative Submission (if applicable)</strong></p>
                <ul>
                  <li>
                    Some instructors may ask you to fill out a Google Form instead.
                  </li>
                  <li>
                    Upload your explanation and supporting documents there.
                  </li>
                </ul>

                <p>
                  <strong>Important:</strong> Sending the initial email promptly is crucial, as many professors require proof that you attempted to communicate at the time of absence to grant a makeup evaluation.
                </p>
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>
              What to do if you miss a lab?
            </div>

            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                <p>
                  Most labs have a scheduled compensatory day, and arrangements can usually be managed even if your specific lab does not have one built into the timetable.
                </p>

                <p><strong>Medical Absence:</strong></p>
                <ul>
                  <li>Visit B.C. Roy Technology Hospital to obtain an official medical certificate.</li>
                  <li>Email the certificate to the respective professor.</li>
                  <li>Politely request a compensatory lab session.</li>
                </ul>

                <p><strong>Non-Medical Absence:</strong></p>
                <ul>
                  <li>Email or speak directly with the professor.</li>
                  <li>Clearly explain your situation.</li>
                  <li>Request a way to compensate for the missed lab.</li>
                </ul>

                <p>
                  Instructors are generally understanding and will help you find a suitable solution to make up for the missed work.
                </p>
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>
              How can I change my Extra Academic Activity (EAA)?
            </div>

            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                <p>
                  Changing your Extra Academic Activity (EAA) requires official approval and coordination between the gymkhana and faculty members involved.
                </p>

                <p><strong>Follow these steps:</strong></p>

                <ul>
                  <li>
                    <strong>Email the Technology Students Gymkhana (TSG) President:</strong>
                    Formally request the change and provide a valid, well-reasoned explanation.
                  </li>
                  <li>
                    <strong>Inform your current EAA faculty coordinator:</strong>
                    Discuss your decision and notify them about your intent to switch.
                  </li>
                  <li>
                    <strong>Contact the new EAA faculty coordinator:</strong>
                    Confirm whether they can accommodate you in the desired activity.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className='accordion-item'>
            <div className='accordion-item-header'>
              Where can you get PYQs?
            </div>

            <div className='accordion-item-body'>
              <div className='accordion-item-body-content'>
                <p>
                  There are multiple sources to get past year question papers (PYQs):
                </p>

                <ul>
                  <li>
                    <strong>IQPS:</strong> An Intelligent Question Paper Search platform created by MetaKGP.
                    It allows you to search the central library repository by course name, year, or semester,
                    and also upload scanned papers.
                  </li>

                  <li>
                    <strong>KGPellence:</strong> A student welfare mobile app that provides organized academic resources
                    like slides, notes, topper tips, and PYQs with solutions across departments.
                  </li>

                  <li>
                    <strong>Programming and Data Structures (PDS) Coursework:</strong>{" "}
                    <a href="https://cse.iitkgp.ac.in/~pds/" target="_blank" rel="noreferrer">
                      https://cse.iitkgp.ac.in/~pds/
                    </a>
                    <br />
                    Dedicated repository for PDS course materials and PYQs.
                  </li>

                  <li>
                    <strong>Institute PYQ Portal:</strong>{" "}
                    <a href="http://10.18.24.75/peqp/" target="_blank" rel="noreferrer">
                      http://10.18.24.75/peqp/
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FAQTag>
  );
};

const FAQTag = styled.section`
  position: relative;
  padding-bottom: 6vh;
  min-padding-bottom: 32px;
  padding-top: 4vh;
  h1 {
    font-weight: 700;
  }
`;

export default FAQ;
